export const separators = {
  twoPoints: ':',
  slash: '/',
  space: ' ',
  dot: '.',
  comma: ',',
};
